export default __webpack_public_path__ + "static/media/bg7.d8b4e5e7.png";